const steps = document.querySelectorAll(".step");
const ritualImage = document.getElementById("ritualImage");

const defaultImage = window.defaultRitualImage;

steps.forEach(step => {

    const header = step.querySelector(".step-header");

    header.addEventListener("click", () => {

        // Was this step already open?
        const isActive = step.classList.contains("active");

        // Close all steps
        steps.forEach(item => item.classList.remove("active"));

        // If it was already open, show default image and stop
        if (isActive) {

            ritualImage.style.opacity = 0;

            setTimeout(() => {

                ritualImage.src = defaultImage;

                ritualImage.style.opacity = 1;

            },150);

            return;
        }

        // Open clicked step
        step.classList.add("active");

        ritualImage.style.opacity = 0;

        setTimeout(() => {

            ritualImage.src = step.dataset.image;

            ritualImage.style.opacity = 1;

        },150);

    });

});